import request from '@/plugin/axios'


export function doCandelUserBind(userId) {
  return request({
    url: '/api/jhi-users/doCandelUserBind/' + userId,
    method: 'post',
  })
}
export function doUserBindWechat(data) {
  return request({
    url: '/api/jhi-users/bindWechat',
    method: 'post',
    data: data
  })
}
export function userLoginApproval(topic) {
  return request({
    url: '/api/jhi-users/userLoginApproval/' + topic,
    method: 'post',
  })
}